import { useQuery } from '@apollo/client';
import { useWorkspace } from '../../providers/WorkspaceProvider';
import styles from './InternalFileSelection.module.scss';
import Select from 'react-select';
import { loader } from 'graphql.macro';
import { useState } from 'react';
import { useOnlineStatus } from '../../hooks/offline-hooks/offline-misc';

const interalFilesQuery = loader('./InternalFileSelection.fetch.graphql');

export default function InternalFileSelection({
  onSubmit = () => {},
  clear = false,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const { workspace } = useWorkspace();
  const online = useOnlineStatus();
  const { data: { files = [] } = {} } = useQuery(interalFilesQuery, {
    skip: !workspace?.id || !online,
    fetchPolicy: 'cache-first',
    variables: {
      options: {
        filters: [
          {
            field: 'workspaceId',
            operator: 'or',
            value: [`${workspace?.id}`, null],
          },
          {
            field: 'url',
            operator: 'ne',
            value: [null],
          },
        ],
      },
    },
  });
  const fileOptions = files?.map((f) => ({ value: f.id, label: f.name, ...f }));

  return (
    <div>
      <Select
        className={styles.select}
        placeholder="Select Internal File"
        options={fileOptions}
        value={selectedFile}
        onChange={(file) => {
          setSelectedFile(file);
          onSubmit({ url: file.url, name: file.name });
          if (!!clear) {
            setSelectedFile(null);
          }
        }}
      />
    </div>
  );
}
